module.exports = __webpack_public_path__ + "img/wei_active.5f50359e.png";